export const isDemoSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.startsWith("demo.");
};

export const getMainAppUrl = (): string => {
  const hostname = window.location.hostname;
  const mainHost = hostname.replace(/^demo\./, "");
  const protocol = window.location.protocol;
  const port = window.location.port ? `:${window.location.port}` : "";
  return `${protocol}//${mainHost}${port}`;
};
